import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ColorsFilter from 'components/essentials/ColorsFilter';
const PDPUpholsteryColorFilters = t0 => {
  const $ = _c(8);
  const {
    activeColorFilters,
    showMobileColorFilter: t1,
    showRowInMobile: t2,
    toggleColorFilter
  } = t0;
  const showMobileColorFilter = t1 === undefined ? false : t1;
  const showRowInMobile = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== activeColorFilters) {
    t3 = activeColorFilters.reduce(_temp, {});
    $[0] = activeColorFilters;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const colors = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["beige/white", "black", "blue", "brown", "green", "gray", "orange", "pink", "red", "white", "yellow"];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== colors || $[4] !== showMobileColorFilter || $[5] !== showRowInMobile || $[6] !== toggleColorFilter) {
    t5 = <ColorsFilter colors={t4} onSelectColor={toggleColorFilter} selectedColors={colors} showRowInMobile={showRowInMobile} showMobileColorFilter={showMobileColorFilter} />;
    $[3] = colors;
    $[4] = showMobileColorFilter;
    $[5] = showRowInMobile;
    $[6] = toggleColorFilter;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
PDPUpholsteryColorFilters.propTypes = {
  activeColorFilters: PropTypes.array,
  toggleColorFilter: PropTypes.func,
  showRowInMobile: PropTypes.bool,
  showMobileColorFilter: PropTypes.bool
};
export default PDPUpholsteryColorFilters;
function _temp(acc, item) {
  return {
    ...acc,
    [item]: true
  };
}